import React from 'react';

import * as buttonConstants from '../buttonConstants';

import Button from '../Button';


function CtaButton(props) {

    return (
        <Button
            {...props}
            flavor={buttonConstants.FLAVOR_CTA}
        />
    );
}


CtaButton.propTypes = {...Button.propTypes};

CtaButton.defaultProps = {...Button.defaultProps};


export default CtaButton;
